<template>
<div class="share-link">
  <b-modal modal-class="share-modal" id="share-link" ref="share-link" centered no-fade hide-footer hide-header>
      <div class="modal-header">
        <div class="modal-logo">
          <h4 class="title">{{$t('Help_sharing')}}</h4>
        </div>  
      </div>    
      <div class="modal-body">
       <div class="share-box">
         <span class="media-icon">
             <b-link target="_blank" class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" href="https://www.facebook.com/">
                <i class="fa fa-lg fa-facebook-square"></i>
             </b-link>
         </span>
         <span class="media-icon">
             <b-link target="_blank" class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" href="https://twitter.com/?lang=en">
                <i class="fa fa-lg fa-twitter"></i>
             </b-link>
         </span>
         <span class="media-icon">
             <b-link target="_blank" class="btn btn-neutral btn-icon-only btn-dribbble btn-round btn-lg" href="https://www.instagram.com/accounts/login/?hl=en">
               <i class="fa fa-instagram"></i>
             </b-link>
         </span>
         <!-- <span class="media-icon">
             <b-link target="_blank" class="btn btn-icon-only btn-danger btn-round btn-lg" href="https://twitter.com/?lang=en">
                <i class="fa fa-lg fa-google-plus"></i>
             </b-link>
         </span> -->
       </div>  
        <b-input-group>
          <!-- http://88.99.171.147:3000/#/Project-details -->
          <b-form-input :readonly="true" placeholder="share Url" :value="shareUrl"></b-form-input>
          <b-input-group-append>
            <b-button v-clipboard="copyData" variant="success" @success="handleSuccess">{{$t('Copy')}}</b-button>
            
          </b-input-group-append>
        </b-input-group>  
      </div>    
     
      <div class="modal-footer">
          <div class="left-btn">
               <base-button type="default" @click="hideModal">{{$t('Close')}}</base-button>
          </div> 
      </div>    
  </b-modal>
</div>
</template>

<script>
import { clipboard } from 'vue-clipboards';
  export default {
    directives: { clipboard },
    props:['queryParams'],
    shareUrl:'',
    data(){
        return{
          copyData: ''
        }
    },
    methods: {
      hideModal() {
        this.$refs['share-link'].hide()
        console.log("share query", this.queryParams);
      },
       handleSuccess(e) {
            console.log(e.text);
            this.copyData = e.text;
           
        },
    },
    mounted() {

      this.shareUrl = 'http://88.99.171.147:3000/#/Project-details?q=' + this.$route.query.q;
      this.copyData = this.shareUrl;
    }
  }
</script>